import { clamp, getDevicePixelRatio, isWebPSupported } from '@djs';
import { envs } from '../core/env';

let isWebPSupport = false;
isWebPSupported((isSupport) => (isWebPSupport = isSupport));

const realDpr = getDevicePixelRatio();
const dpr = clamp(Math.round(realDpr), 1, 3);
const suffix = dpr === 1 ? '' : `@${dpr}x`;

interface GetImageSourceOptions {
  format: 'svg' | 'png' | 'jpeg';
  webp?: boolean;
  ratio?: boolean;
}

function getAssetSource(path: string, name: string, format: string): string {
  const staticAssetsUrl = envs.STATIC_ASSETS_URL;

  return `${staticAssetsUrl}${path}/${name}.${format}`;
}

function getImageSource(path: string, name: string, options: GetImageSourceOptions): string {
  const { format, webp, ratio } = options;
  const formatSource = webp && isWebPSupport ? 'webp' : format;
  const fullName = `${name}${ratio ? suffix : ''}`;

  return getAssetSource(path, fullName, formatSource);
}

export const imageGetters = {
  iosSteps: (key: string) => {
    return getImageSource('pwa/steps/ios', key, { format: 'png', webp: true, ratio: true });
  },
  oldSafari: (key: string) => {
    return getImageSource('pwa/steps/ios/old-safari', key, { format: 'png', webp: true, ratio: true });
  },
  background: () => getImageSource('pwa/background', 'background', { format: 'png', webp: true, ratio: true }),
};
